// import React, { useState, useCallback } from "react";
// import ReportDetails from "../../components/Reports/components/ReportDetails";
// // import PaidModal from "./PaidModal";
// import PaidModal from "../../components/Reports/components/PaidModal";
// // import { useReportsData } from "../../../Contexts/ReportsContext";
// import { useReportsData } from "../../Contexts/ReportsContext";

// const ModalManager = ({
//   isReportDetailsOpen,
//   selectedTenantData,
//   onCloseAll,
//   onMarkAsPaidSuccess,
// }) => {
//   const [isPaidModalOpen, setIsPaidModalOpen] = useState(false);
//   const [selectedTenant, setSelectedTenant] = useState(null);
//   const [selectedPaymentType, setSelectedPaymentType] = useState("");
//   const [selectedFile, setSelectedFile] = useState(null);

//   // Get the context functions for updating local data
//   const { handleMarkAsPaidLocally } = useReportsData();

//   // 🔥 OPTIMIZED: Handle opening PaidModal from ReportDetails
//   const handleMarkAsPaidClick = useCallback(
//     (tenantData) => {
//       console.log(
//         "🔄 ModalManager: Opening PaidModal with tenant data:",
//         tenantData
//       );

//       // Use the passed tenantData or fall back to selectedTenantData
//       const dataToUse = tenantData || selectedTenantData;

//       if (!dataToUse) {
//         console.error(
//           "❌ ModalManager: No tenant data provided to handleMarkAsPaidClick"
//         );
//         alert("Error: No tenant data available. Please try again.");
//         return;
//       }

//       // Validate required fields for payment processing
//       const requiredFields = [
//         "agreement_id",
//         "building_id",
//         "unit_id",
//         "tenant_id",
//         "amount",
//       ];
//       const missingFields = requiredFields.filter((field) => !dataToUse[field]);

//       if (missingFields.length > 0) {
//         console.error(
//           "❌ ModalManager: Missing required fields:",
//           missingFields
//         );
//         console.error("Tenant data:", dataToUse);
//         alert("Error: Incomplete tenant data. Please refresh and try again.");
//         return;
//       }

//       setSelectedTenant(dataToUse);
//       setIsPaidModalOpen(true);
//     },
//     [selectedTenantData]
//   );

//   // 🔥 OPTIMIZED: Handle successful payment marking
//   const handleMarkAsPaidSuccessInternal = useCallback(() => {
//     console.log("✅ ModalManager: Payment marked as paid successfully");

//     const tenantToUpdate = selectedTenant || selectedTenantData;

//     // Update local data in context
//     if (tenantToUpdate && handleMarkAsPaidLocally) {
//       handleMarkAsPaidLocally(tenantToUpdate);
//     }

//     // Close all modals and reset state
//     setIsPaidModalOpen(false);
//     setSelectedTenant(null);
//     setSelectedPaymentType("");
//     setSelectedFile(null);
//     onCloseAll();

//     // Notify parent component
//     if (onMarkAsPaidSuccess) {
//       onMarkAsPaidSuccess(tenantToUpdate);
//     }
//   }, [
//     selectedTenant,
//     selectedTenantData,
//     handleMarkAsPaidLocally,
//     onCloseAll,
//     onMarkAsPaidSuccess,
//   ]);

//   // 🔥 OPTIMIZED: Handle closing PaidModal (go back to ReportDetails)
//   const handleClosePaidModal = useCallback(() => {
//     console.log(
//       "🔙 ModalManager: Closing PaidModal, returning to ReportDetails"
//     );
//     setIsPaidModalOpen(false);
//     setSelectedTenant(null);
//     setSelectedPaymentType("");
//     setSelectedFile(null);
//     // Don't close ReportDetails, just go back to it
//   }, []);

//   // 🔥 OPTIMIZED: Handle closing ReportDetails
//   const handleCloseReportDetails = useCallback(() => {
//     console.log("🔙 ModalManager: Closing ReportDetails");
//     setSelectedTenant(null);
//     setSelectedPaymentType("");
//     setSelectedFile(null);
//     onCloseAll();
//   }, [onCloseAll]);

//   // 🔥 OPTIMIZED: Memoized modal state validation
//   const shouldShowReportDetails =
//     isReportDetailsOpen && !isPaidModalOpen && selectedTenantData;
//   const shouldShowPaidModal = isPaidModalOpen && selectedTenant;

//   // 🔥 DEBUG: Log modal state changes
//   React.useEffect(() => {
//     console.log("📊 ModalManager State:", {
//       isReportDetailsOpen,
//       isPaidModalOpen,
//       hasSelectedTenantData: !!selectedTenantData,
//       hasSelectedTenant: !!selectedTenant,
//       shouldShowReportDetails,
//       shouldShowPaidModal,
//     });
//   }, [
//     isReportDetailsOpen,
//     isPaidModalOpen,
//     selectedTenantData,
//     selectedTenant,
//     shouldShowReportDetails,
//     shouldShowPaidModal,
//   ]);

//   return (
//     <>
//       {/* ReportDetails Modal */}
//       {shouldShowReportDetails && (
//         <ReportDetails
//           tenantData={selectedTenantData}
//           onClose={handleCloseReportDetails}
//           onMarkAsPaidClick={handleMarkAsPaidClick}
//         />
//       )}

//       {/* PaidModal */}
//       {shouldShowPaidModal && (
//         <PaidModal
//           selectedTenant={selectedTenant}
//           onClose={handleClosePaidModal}
//           onMarkAsPaid={handleMarkAsPaidSuccessInternal}
//           setSelectedPaymentType={setSelectedPaymentType}
//           setSelectedFile={setSelectedFile}
//         />
//       )}
//     </>
//   );
// };

// export default ModalManager;

import React, { useState, useCallback } from "react";

// import { usePayments } from "../../../Contexts/PaymentsContext"; // 🔥 NEW: Import PaymentsContext

import ReportDetails from "../../components/Reports/components/ReportDetails";
// // import PaidModal from "./PaidModal";
import PaidModal from "../../components/Reports/components/PaidModal";
// import { useReportsData } from "../../../Contexts/ReportsContext";
import { useReportsData } from "../../Contexts/ReportsContext";
import { usePayments } from "../../Contexts/PaymentsContext";

const ModalManager = ({
  isReportDetailsOpen,
  selectedTenantData,
  onCloseAll,
  onMarkAsPaidSuccess,
}) => {
  const [isPaidModalOpen, setIsPaidModalOpen] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  // Get the context functions for updating local data
  const { handleMarkAsPaidLocally } = useReportsData();
  const { addPaymentLocally, refreshPayments } = usePayments(); // 🔥 NEW: Get PaymentsContext methods

  // 🔥 OPTIMIZED: Handle opening PaidModal from ReportDetails
  const handleMarkAsPaidClick = useCallback(
    (tenantData) => {
      console.log(
        "🔄 ModalManager: Opening PaidModal with tenant data:",
        tenantData
      );

      // Use the passed tenantData or fall back to selectedTenantData
      const dataToUse = tenantData || selectedTenantData;

      if (!dataToUse) {
        console.error(
          "❌ ModalManager: No tenant data provided to handleMarkAsPaidClick"
        );
        alert("Error: No tenant data available. Please try again.");
        return;
      }

      // Validate required fields for payment processing
      const requiredFields = [
        "agreement_id",
        "building_id",
        "unit_id",
        "tenant_id",
        "amount",
      ];
      const missingFields = requiredFields.filter((field) => !dataToUse[field]);

      if (missingFields.length > 0) {
        console.error(
          "❌ ModalManager: Missing required fields:",
          missingFields
        );
        console.error("Tenant data:", dataToUse);
        alert("Error: Incomplete tenant data. Please refresh and try again.");
        return;
      }

      setSelectedTenant(dataToUse);
      setIsPaidModalOpen(true);
    },
    [selectedTenantData]
  );

  // 🔥 ENHANCED: Handle successful payment marking with cross-context updates
  const handleMarkAsPaidSuccessInternal = useCallback(async () => {
    console.log("✅ ModalManager: Payment marked as paid successfully");

    const tenantToUpdate = selectedTenant || selectedTenantData;

    if (!tenantToUpdate) {
      console.error("❌ ModalManager: No tenant data available for updates");
      return;
    }

    try {
      // 1. Update ReportsContext (remove from pending payments)
      if (handleMarkAsPaidLocally) {
        console.log("🔄 ModalManager: Updating ReportsContext...");
        handleMarkAsPaidLocally(tenantToUpdate);
      }

      // 2. 🔥 NEW: Update PaymentsContext (add to payments list)
      if (addPaymentLocally) {
        console.log("🔄 ModalManager: Adding payment to PaymentsContext...");

        // Prepare payment data for PaymentsContext
        const paymentData = {
          entity_id: `payment_${Date.now()}`, // Temporary ID until we get real one from API
          tenant_name:
            tenantToUpdate.first_name && tenantToUpdate.last_name
              ? `${tenantToUpdate.first_name} ${tenantToUpdate.last_name}`
              : tenantToUpdate.tenant_name || "Unknown Tenant",
          building_name: tenantToUpdate.building_name,
          unit_name: tenantToUpdate.unit_name,
          building_id: tenantToUpdate.building_id,
          unit_id: tenantToUpdate.unit_id,
          tenant_id: tenantToUpdate.tenant_id,
          agreement_id: tenantToUpdate.agreement_id,
          amount: tenantToUpdate.amount,
          local_amount:
            tenantToUpdate.local_amount ||
            `₹${parseInt(tenantToUpdate.amount).toLocaleString("en-IN")}`,
          month: tenantToUpdate.month,
          year: tenantToUpdate.year,
          nature: tenantToUpdate.nature || "rent",
          payment_mode: selectedPaymentType || "manual",
          payment_id: "manual",
          description: tenantToUpdate.description || "",
          is_check: false,
        };

        addPaymentLocally(paymentData);
        console.log(
          "✅ ModalManager: Successfully added payment to PaymentsContext"
        );
      }

      // 3. Close all modals and reset state
      setIsPaidModalOpen(false);
      setSelectedTenant(null);
      setSelectedPaymentType("");
      setSelectedFile(null);
      onCloseAll();

      // 4. Notify parent component
      if (onMarkAsPaidSuccess) {
        onMarkAsPaidSuccess(tenantToUpdate);
      }

      // 5. 🔥 OPTIONAL: Refresh PaymentsContext after a short delay to get accurate server data
      setTimeout(() => {
        console.log(
          "🔄 ModalManager: Refreshing PaymentsContext to sync with server..."
        );
        refreshPayments({ fetchAll: false }); // Fetch first page to get latest data
      }, 2000);
    } catch (error) {
      console.error(
        "❌ ModalManager: Error during cross-context updates:",
        error
      );

      // Still close modals even if there's an error
      setIsPaidModalOpen(false);
      setSelectedTenant(null);
      setSelectedPaymentType("");
      setSelectedFile(null);
      onCloseAll();

      // Show user-friendly error message
      alert(
        "Payment was processed, but there was an issue updating the interface. Please refresh the page."
      );
    }
  }, [
    selectedTenant,
    selectedTenantData,
    selectedPaymentType,
    handleMarkAsPaidLocally,
    addPaymentLocally,
    refreshPayments,
    onCloseAll,
    onMarkAsPaidSuccess,
  ]);

  // 🔥 OPTIMIZED: Handle closing PaidModal (go back to ReportDetails)
  const handleClosePaidModal = useCallback(() => {
    console.log(
      "🔙 ModalManager: Closing PaidModal, returning to ReportDetails"
    );
    setIsPaidModalOpen(false);
    setSelectedTenant(null);
    setSelectedPaymentType("");
    setSelectedFile(null);
    // Don't close ReportDetails, just go back to it
  }, []);

  // 🔥 OPTIMIZED: Handle closing ReportDetails
  const handleCloseReportDetails = useCallback(() => {
    console.log("🔙 ModalManager: Closing ReportDetails");
    setSelectedTenant(null);
    setSelectedPaymentType("");
    setSelectedFile(null);
    onCloseAll();
  }, [onCloseAll]);

  // 🔥 OPTIMIZED: Memoized modal state validation
  const shouldShowReportDetails =
    isReportDetailsOpen && !isPaidModalOpen && selectedTenantData;
  const shouldShowPaidModal = isPaidModalOpen && selectedTenant;

  // 🔥 DEBUG: Log modal state changes
  React.useEffect(() => {
    console.log("📊 ModalManager State:", {
      isReportDetailsOpen,
      isPaidModalOpen,
      hasSelectedTenantData: !!selectedTenantData,
      hasSelectedTenant: !!selectedTenant,
      shouldShowReportDetails,
      shouldShowPaidModal,
      selectedPaymentType,
    });
  }, [
    isReportDetailsOpen,
    isPaidModalOpen,
    selectedTenantData,
    selectedTenant,
    shouldShowReportDetails,
    shouldShowPaidModal,
    selectedPaymentType,
  ]);

  return (
    <>
      {/* ReportDetails Modal */}
      {shouldShowReportDetails && (
        <ReportDetails
          tenantData={selectedTenantData}
          onClose={handleCloseReportDetails}
          onMarkAsPaidClick={handleMarkAsPaidClick}
        />
      )}

      {/* PaidModal */}
      {shouldShowPaidModal && (
        <PaidModal
          selectedTenant={selectedTenant}
          onClose={handleClosePaidModal}
          onMarkAsPaid={handleMarkAsPaidSuccessInternal}
          setSelectedPaymentType={setSelectedPaymentType}
          setSelectedFile={setSelectedFile}
        />
      )}
    </>
  );
};

export default ModalManager;
